import React, { ReactNode } from 'react';
import dynamic from 'next/dynamic';
import { TopbarButtonProps, TopbarButton } from '@teko/teko-ecommerce';
import type { IconBaseProps } from '@teko/ds-icon';

const BusinessCustomerOutlined = dynamic(() =>
  import('@teko/ds-icon').then((mod) => mod.BusinessCustomerOutlined),
);
const HeadphoneOutlined = dynamic(() =>
  import('@teko/ds-icon').then((mod) => mod.HeadphoneOutlined),
);
const ShowroomOutlined = dynamic(() =>
  import('@teko/ds-icon').then((mod) => mod.ShowroomOutlined),
);
const TvNewOutlined = dynamic(() =>
  import('@teko/ds-icon').then((mod) => mod.TvNewOutlined),
);
const PromoOutlined = dynamic(() =>
  import('@teko/ds-icon').then((mod) => mod.PromoOutlined),
);
const BuildPcOutlined = dynamic(() =>
  import('@teko/ds-icon').then((mod) => mod.BuildPcOutlined),
);
const MailOutlined = dynamic(() =>
  import('@teko/ds-icon').then((mod) => mod.MailOutlined),
);
const FacebookFilled = dynamic(() =>
  import('@teko/ds-icon').then((mod) => mod.FacebookFilled),
);
const ShopOutlined = dynamic(() =>
  import('@teko/ds-icon').then((mod) => mod.ShopOutlined),
);
const PhoneOutlined = dynamic(() =>
  import('@teko/ds-icon').then((mod) => mod.PhoneOutlined),
);

interface IconData {
  iconName: string;
  color: string;
  size: number;
}

// @ts-ignore
export interface ITopBarButtonConfig extends TopbarButtonProps {
  key?: number;
  icon?: IconData;
}

/* map from iconName to component icon */
const iconMap = new Map<string, React.ComponentType<IconBaseProps>>([
  ['BusinessCustomerOutlined', BusinessCustomerOutlined],
  ['HeadphoneOutlined', HeadphoneOutlined],
  ['TvNewOutlined', TvNewOutlined],
  ['ShowroomOutlined', ShowroomOutlined],
  ['BuildPcOutlined', BuildPcOutlined],
  ['PromoOutlined', PromoOutlined],
  ['MailOutlined', MailOutlined],
  ['FacebookFilled', FacebookFilled],
  ['ShopOutlined', ShopOutlined],
  ['PhoneOutlined', PhoneOutlined],
]);

const renderTopBarIcon = (iconData: IconData) => {
  const { iconName, ...rest } = iconData;
  const Comp = iconMap.get(iconName);
  return Comp ? <Comp {...rest} /> : null;
};

/* render top bar button by its config */
export const renderTopBarButton = (
  topBarButtonConfig: ITopBarButtonConfig,
): ReactNode => {
  const { children, key, icon, ...rest } = topBarButtonConfig;
  const props = {
    ...(!!icon ? { icon: renderTopBarIcon(icon) } : {}),
    ...rest,
  };
  return (
    <TopbarButton {...props} key={key}>
      {children}
    </TopbarButton>
  );
};
